const API_KEY = "38c6cb7b6d6c1bbe615954c73f06a9af";
export { API_KEY };
